import dotenv from 'dotenv';
dotenv.config();

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import store from './store';
import router from './router';
import PerfectScrollbar from 'perfect-scrollbar';
import qs from 'qs';
import appI18n from './i18n/language';
import execPresets from '@/config/presets/index';
import '@/assets/scss/main.scss';
import VueClipboard from 'vue-clipboard2';
import Element from 'element-ui';

execPresets({ router });
Vue.config.productionTip = false;
Vue.use(VueI18n);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

let query = qs.parse(window.location.search.substring(1));

const i18n = appI18n.init(query.locale || window.navigator.language.split('-')[0] || 'en');

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
});

window.counter = 0;
new Vue({
  store,
  router,
  i18n,

  mounted() {
    new PerfectScrollbar('#app', {
      wheelPropagation: true,
      handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
    });
  },
  methods: {
    getQueryParameters() {
      let queryString = qs.parse(window.location.search.substring(1));
      return queryString;
    },
  },
  render: h => h(App),
}).$mount('#app');
